import React from 'react';
import { Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';

const withAuth = (Component: React.ComponentType) => {
    const AuthComponent = (props: any) => {
        const token = Cookies.get('api_token');
        if (!token) {
            return <Navigate to="/login" />;
        }
        return <Component {...props} />;
    };

    return AuthComponent;
};

export default withAuth;
